import site_logo from "../assets/logo/logo.png";
import short_logo from "../assets/logo/shortlogo.png";
export const logo = site_logo;
export const shortLogo = short_logo;
export const title = 'Haveidea';
export const website = 'haveidea.online';   
export const websiteUrl = 'https://haveidea.online/';
export const ADMIN_UID = 'tamanna';